import { useState } from "react";

import { Link } from 'react-scroll'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function Navbar(props){

    const [dropped, setDropped] = useState(false);

    const handleClick = e => {
        const button = document.getElementById("dropdownButton");
        button.style.transition = "transform 0.3s ease-out"
        if ( !dropped){
            button.style.transform = "rotate(180deg)";
        } else {
            button.style.transform = "none";
        }
        setDropped(!dropped);
    }

    return (
        <div className="navbar">
            {
                document.documentElement.clientWidth > 768 ? (
                    <ul className="navbar-list">
                        <li className="navbar-list-item">
                        <Link to="about" spy={true} smooth={true} duration={1000}>邱丽珠</Link>
                        </li>
                        <li className="navbar-list-item">
                            <ul className="navbar-list">
                                <li className="navbar-list-item">
                                    <Link to="about" spy={true} smooth={true} duration={1000}><span className="navbar-item-text">About</span></Link>
                                </li>
                                <li className="navbar-list-item">
                                    <Link to="testimonials" spy={true} smooth={true} duration={1000}><span className="navbar-item-text">Testimonials</span></Link>
                                </li>
                                <li className="navbar-list-item">
                                    <Link to="contact" spy={true} smooth={true} duration={1000}><span className="navbar-item-text">Contact</span></Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                ) : (
                    <>
                        <ul className="navbar-list">
                            <li className="navbar-list-item">邱丽珠</li>
                            <li className="navbar-list-item" onClick = {handleClick}>
                                <ArrowDropDownIcon fontSize="large" id="dropdownButton"/>
                            </li>
                        </ul>
                        <div className={dropped ? "dropdown" : "dropdown-hidden"}>
                            <ul className={dropped ? "dropdown-list" : "dropdown-list hidden"}>
                                <li className="dropdown-item">
                                    <Link to="about" spy={true} smooth={true} duration={1000} onClick = {handleClick}>About</Link>
                                </li>
                                <li className="dropdown-item">
                                    <Link to="testimonials" spy={true} smooth={true} duration={1000} onClick = {handleClick}>Testimonial</Link>
                                </li>
                                <li className="dropdown-item">
                                    <Link to="contact" spy={true} smooth={true} duration={1000} onClick = {handleClick}>Contact</Link>
                                </li>
                            </ul>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default Navbar;